import type { Ref } from "react";

interface ToolApprovalOptionButtonProps {
	/** 0 始まり。番号には +1 した値を出す。 */
	index: number;
	label: string;
	onClick: () => void;
	buttonRef?: Ref<HTMLButtonElement>;
}

/** ツール承認の選択肢。押すとすぐ決定するので選択状態を持たず、左端に番号を出す。 */
export function ToolApprovalOptionButton({
	index,
	label,
	onClick,
	buttonRef,
}: ToolApprovalOptionButtonProps) {
	return (
		<button
			ref={buttonRef}
			type="button"
			onClick={onClick}
			className="flex w-full items-center gap-3 rounded-4 bg-surface-1 px-3 py-2.5 text-left text-ui text-fg-1 shadow-ring transition-colors enabled:hover:bg-menu-hover-bg enabled:cursor-pointer enabled:hover:text-fg-0 disabled:cursor-not-allowed disabled:opacity-50"
		>
			<span className="shrink-0 text-fg-3 tabular-nums">{index + 1}</span>
			<span className="min-w-0 flex-1 font-medium">{label}</span>
		</button>
	);
}
